import React from 'react';
import axios from 'axios';
import { useAuth } from 'oidc-react';

export function createStatusApiClient(accessToken) {
  return {
    get(url, config = {}) {
      return axios.get(url, {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      });
    },
  };
}

export function normalizeStatusApiError(error) {
  const status = error?.response?.status ?? null;
  return {
    status,
    unauthorized: status === 401,
    message: 'Status API request failed',
  };
}

export default function useStatusApi() {
  const auth = useAuth();
  const accessToken = auth.userData?.access_token;
  const client = React.useMemo(() => (accessToken ? createStatusApiClient(accessToken) : null), [accessToken]);

  return {
    ready: client !== null,
    get: client?.get,
  };
}
